export const SET_NEXT_BET = 'openBets/SET_NEXT_BET';
export const SET_PREV_BET = 'openBets/SET_PREV_BET';
export const VIEW_ENTER = 'openBets/VIEW_ENTER';
export const VIEW_LEAVE = 'openBets/VIEW_LEAVE';
export const SET_BETS = 'openBets/SET_BETS';
export const SET_CURRENT_BET = 'openBets/SET_CURRENT_BET';
export const SHOW_LIST = 'openBets/SHOW_LIST';
export const SET_CURRENT_SELECTION = 'openBets/SET_CURRENT_SELECTION';
export const UPDATE_BET_CASH_OUT_STATUS = 'openBets/UPDATE_BET_CASH_OUT_STATUS';
export const UPDATE_VIEW_STATE = 'openBets/UPDATE_VIEW_STATE';
export const SET_VIEW_IS_LOADING = 'openBets/SET_VIEW_IS_LOADING';
export const LOAD_MORE = 'openBets/LOAD_MORE';
export const SHOW_CONGRATULATIONS = 'openBets/SHOW_CONGRATULATIONS';

export const setCurrentBet = (id) => ({
  type: SET_CURRENT_BET,
  id
});

export const setNextBet = () => ({
  type: SET_NEXT_BET
});

export const setPrevBet = () => ({
  type: SET_PREV_BET
});

export const showList = () => ({
  type: SHOW_LIST
});

export const viewEnter = () => ({
  type: VIEW_ENTER
});

export const viewLeave = () => ({
  type: VIEW_LEAVE
});

export const setBets = (results, incremental) => ({
  type: SET_BETS,
  results,
  incremental
});

export const setCurrentSelection = (id) => ({
  type: SET_CURRENT_SELECTION,
  id
});

export const showCongratulations = (id, price) => ({
  type: SHOW_CONGRATULATIONS,
  id,
  price
});

export const updateBetCashOutStatus = (id, status) => ({
  type: UPDATE_BET_CASH_OUT_STATUS,
  id,
  status
});

export const updateViewState = (currentBetId, shouldShowList) => ({
  type: UPDATE_VIEW_STATE,
  currentBetId,
  showList: shouldShowList
});

export const setViewIsLoading = loading => ({
  type: SET_VIEW_IS_LOADING,
  loading
});

export const loadMore = () => ({
  type: LOAD_MORE
});
